import { render, staticRenderFns } from "./AboutUsIntroduction.vue?vue&type=template&id=186b7303"
import script from "./AboutUsIntroduction.vue?vue&type=script&lang=js"
export * from "./AboutUsIntroduction.vue?vue&type=script&lang=js"
import style0 from "./AboutUsIntroduction.vue?vue&type=style&index=0&id=186b7303&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports